import httpClient from '../api/httpClient'

export const getStatisticByPersonId = async (payload) => {
  const endpoint = `/RefStatistics/get?personId=${payload}`
  return httpClient.get(endpoint)
}

export const insertStatistic = async (payload) => {
  // Type
  // 1 - Profile Visit
  // 2 - Like
  // 2 - Unlike
  // 3 - Share
  // 4 - Comments
  // 5 - Threads
  // 6 - Bookmarks
  // 8 - Unlike
  // 9 - Un bookmarked
  // 10 - Comment deleted
  // 11 - Thread deleted
 
  const endpoint = '/RefStatistics'
  return httpClient.post(endpoint, payload)
}

export default {
  getStatisticByPersonId,
  insertStatistic
}
